<ejs-dialog id="ejDialogNotebookDownload" (overlayClick)="onOverlayClickOutsideMenu()" (beforeClose)="onDialogClose($event)"
  [visible]="isVisible" [showCloseIcon]="true" [width]="dialogWidth" cssClass="fn-dl-dialog"
  [animationSettings]="animationSettings" [target]="dialogDragTarget" [allowDragging]="allowDialogDragging"
  [enableResize]="false" isModal="true" [zIndex]="10000">
  <ng-template #header>
    <div class="fn-dl-title">Download Notebook</div>
    <div class="fn-dl-subtitle" *ngIf="subtitle" [attr.title]="subtitle">{{subtitle}}</div>
  </ng-template>
  <ng-template #content>
    <div class="nbdl" *ngIf="state">
      <ol class="nbdl-steps">
        <li *ngFor="let step of steps" class="nbdl-step" [ngClass]="'nbdl-step--' + stepStatus(step.key)">
          <span class="nbdl-dot"></span><span class="nbdl-label">{{step.label}}</span>
        </li>
      </ol>

      <div class="nbdl-status" [ngSwitch]="state.step">
        <ng-container *ngSwitchCase="'requesting'">
          <img src="/assets/images/progress-spinner.gif" class="nbdl-spinner" alt="" />
          <span>Sending request... {{elapsedText}}</span>
        </ng-container>

        <ng-container *ngSwitchCase="'generating'">
          <img src="/assets/images/progress-spinner.gif" class="nbdl-spinner" alt="" />
          <span class="nbdl-text">Generating your {{fileTypeLabel}}... {{elapsedText}}</span>
          <button type="button" class="nbdl-more" (click)="toggleDetails()" [attr.aria-expanded]="showDetails">{{showDetails ? 'Hide details' : 'Details'}}</button>
        </ng-container>

        <ng-container *ngSwitchCase="'downloading'">
          <img src="/assets/images/progress-spinner.gif" class="nbdl-spinner" alt="" />
          <span>Downloading {{loadedMegabytes}}<ng-container *ngIf="totalMegabytes"> of {{totalMegabytes}}</ng-container> MB</span>
        </ng-container>

        <ng-container *ngSwitchCase="'done'">
          <span class="nbdl-ok">&#10003;</span>
          <span>Download complete</span>
        </ng-container>

        <ng-container *ngSwitchCase="'error'">
          <span class="nbdl-err">!</span>
          <span class="nbdl-text">{{errorHeadline}}</span>
          <button type="button" class="nbdl-more" (click)="toggleDetails()" [attr.aria-expanded]="showDetails">{{showDetails ? 'Hide details' : 'Details'}}</button>
        </ng-container>
      </div>

      <div class="nbdl-bar" *ngIf="state.step === 'downloading' && totalMegabytes">
        <div class="nbdl-bar-fill" [style.width.%]="progressPercent"></div>
      </div>

      <ul class="nbdl-details" *ngIf="showDetails && state.step === 'generating'">
        <li>Large notebooks can take several minutes.</li>
        <li>You can close this window. The job keeps running.</li>
        <li>The bell notification will have the file when it is ready.</li>
      </ul>

      <ul class="nbdl-details" *ngIf="showDetails && state.step === 'error'">
        <li *ngIf="state.errorCode === 'TIMEOUT'">The job may still finish. The bell notification will have it.</li>
        <li *ngIf="state.errorCode === 'TIMEOUT'">Retry sends a new request.</li>
        <li *ngIf="state.httpStatus">HTTP status {{state.httpStatus}}</li>
        <li>Reference for support: {{state.requestId}}</li>
      </ul>

      <div class="nbdl-actions">
        <button type="button" class="success" *ngIf="state.step === 'error'" (click)="retry()">Retry</button>
        <button type="button" class="nbdl-close" (click)="close()">Close</button>
      </div>
    </div>
  </ng-template>
</ejs-dialog>
